"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Icon_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Icon"));
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var rem_1 = tslib_1.__importDefault(require("polished/lib/helpers/rem"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var styles_1 = require("../../../common/styles");
var linkClass = 'header-link';
var showmoreLinkClass = 'showmore-link';
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin: ", " 0;\n\n  .", " {\n    text-decoration: none;\n    color: inherit;\n  }\n\n  .", " {\n    position: relative;\n    height: ", ";\n    width: ", ";\n    background: ", ";\n    border-radius: ", ";\n    margin: 0 0 0 0.75em;\n    flex-shrink: 0;\n  }\n\n  ", " {\n    justify-content: normal;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin: ", " 0;\n\n  .", " {\n    text-decoration: none;\n    color: inherit;\n  }\n\n  .", " {\n    position: relative;\n    height: ", ";\n    width: ", ";\n    background: ", ";\n    border-radius: ", ";\n    margin: 0 0 0 0.75em;\n    flex-shrink: 0;\n  }\n\n  ", " {\n    justify-content: normal;\n  }\n"])), rem_1["default"](12), linkClass, showmoreLinkClass, rem_1["default"](19), rem_1["default"](25), function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.largeBorderRadius;
}, utilities_1.mb('s'));
var Header = styled_components_1["default"].h2(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n  margin: 0;\n"], ["\n  ", "\n  margin: 0;\n"])), styles_1.h2);
var StyledIcon = styled_components_1["default"](Icon_1["default"])(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  left: 2px;\n  top: 50%;\n  transform: translateY(-50%);\n  &:nth-child(2) {\n    left: 6px;\n  }\n  &:nth-child(3) {\n    left: 10px;\n  }\n"], ["\n  position: absolute;\n  left: 2px;\n  top: 50%;\n  transform: translateY(-50%);\n  &:nth-child(2) {\n    left: 6px;\n  }\n  &:nth-child(3) {\n    left: 10px;\n  }\n"])));
var C = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, renderShowmoreLink = _a.renderShowmoreLink, _c = _a.as, as = _c === void 0 ? undefined : _c;
    return (react_1["default"].createElement(Wrapper, { className: className + " content-widget-header", as: as },
        react_1["default"].createElement(Header, null, renderShowmoreLink
            ? renderShowmoreLink({
                className: linkClass,
                children: children
            })
            : children),
        renderShowmoreLink &&
            renderShowmoreLink({
                className: showmoreLinkClass,
                children: (react_1["default"].createElement(react_1["default"].Fragment, null,
                    react_1["default"].createElement(StyledIcon, { size: 14, name: "arrow-right", color: "#fff" }),
                    react_1["default"].createElement(StyledIcon, { size: 14, name: "arrow-right", color: "#fff" }),
                    react_1["default"].createElement(StyledIcon, { size: 14, name: "arrow-right", color: "#fff" })))
            })));
};
C.propTypes = {
    className: prop_types_1["default"].string
};
C.defaultProps = {
    className: null
};
exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3;
